import {ReactElement} from "react";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Grid from "@mui/material/Grid";
import Title from "../../components/Title";
import {PageDto} from "../../domain/PageDto";
import {SearchDataFunction} from "../../components/types/SearchDataFunction";
import {useSearchEquityTransactions} from "../../application/EquityTransactionService";
import {EquityTransaction} from "../../domain/transaction/EquityTransaction";
import {TransactionSearchTerm} from "../../domain/transaction/TransactionSearchTerm";
import {Action} from "../../domain/transaction/Action";
import EquityTransactionComponent from "../../components/EquityTransactionComponent";

export default function ActiveEquityTransactionsPage(): ReactElement {

    const searchFn: SearchDataFunction<TransactionSearchTerm, PageDto<EquityTransaction>> = useSearchEquityTransactions({
        assetManager: "",
        counterpart: "",
        fromDate: null,
        instrument: "",
        toDate: null,
        transaction: "",
        states: [Action.ADD, Action.PENDING_STATIC]
    });

    return (
            <Container maxWidth={ false } sx={{ mt: 4, mb: 4 }}>
                { <Toolbar/> }
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 11, lg: 11 }}>
                        <Title>Equity Transactions in Progress</Title>
                    </Grid>
                    <EquityTransactionComponent searchFn={searchFn} />
                </Grid>
            </Container>
    );
}